import React, { ReactNode, useEffect, useState } from "react";
import { Wordle } from "../../images";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import { useAppSelector } from "../../hooks";
import { AuthenticateState } from "../../types/types";
import { useWeb3Auth } from "../../hooks/useWeb3Auth";
import { useWhiteboardRoom } from "../../hooks/useWhiteboardRoom";
import { Redirect } from "react-router-dom";
import { ROUTES } from "../../routes";
import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import "./index.css";
import { createClickEngagementRecorder } from "../../utils/api";

const SmallAppsPage = () => {
  const { authenticateStatus } = useAppSelector((state) => state.auth);
  const { roomDomain } = useWhiteboardRoom();
  const clickRecorder = createClickEngagementRecorder(roomDomain, roomDomain);
  const { t } = useTranslation();

  const { isProticoAuthenticated, currentToken, logined, logout, proticoAuthenticate } =
    useWeb3Auth();
  const [gameOpen, setGameOpen] = useState(false);
  const [proticoToken, setProticoToken] = useState<string | null>(null);

  const renderButton = (
    textKey: string,
    btnKey: string,
    onClickHandler: any,
    extraChildren?: ReactNode
  ) => {
    return (
      <div className="small-apps-login-reminder-container">
        <VerifiedUserIcon fontSize="medium" />
        <h3>{t(textKey)}</h3>
        <Button
          className="small-apps-wallet-connect-btn"
          variant="outlined"
          onClick={onClickHandler}
        >
          {t(btnKey)}
        </Button>
        {extraChildren}
      </div>
    );
  };
    const handleProticoAuthenticate = () => {
    proticoAuthenticate();
  };

  const handleReConnect = (e: React.MouseEvent<HTMLElement>) => {
    // after logout, it will be redirect to b to c page
    logout(`${ROUTES.SMALL_APPS_PAGE}`);
  };
  const handleGameOpen = () => {
    if (!isProticoAuthenticated) {
      alert("Please Login");
    } else {
      clickRecorder("gameOpen");
      setGameOpen(true);
    }
  };
  const getToken = async () => {
    setProticoToken(currentToken.web3AccessToken);
  };
  useEffect(() => {
    if (
      authenticateStatus != AuthenticateState.GUEST &&
      isProticoAuthenticated
    ) {
      getToken();
    }
  }, [authenticateStatus, isProticoAuthenticated]);

  if (!logined)
    return (
      <Redirect
        to={{
          pathname: ROUTES.LOGIN_PAGE,
        }}
      />
    );
  return (
    <div style={{ width: "100%", height: "100%" }}>
      {gameOpen ? (
        <iframe
          style={{ width: "100%", height: "100%" }}
          src={
            "http://localhost:3000/?token=" +
            proticoToken +
            "&domain=" +
            roomDomain
          }
        />
      ) : (
        <div>
          <h1>Game Center</h1>
          <div style={{ margin: "30px", textAlign: "start" }}>
            <img
              onClick={handleGameOpen}
              style={{ width: "80px" }}
              src={Wordle}
              alt="Wordle"
            />
          </div>
          {authenticateStatus === AuthenticateState.GUEST ? (
            renderButton(
              "SMALL_APPS_Signin_Request",
              "PIN_Signin_Connect_Wallet",
              handleReConnect
            )
          ) : (
            authenticateStatus === AuthenticateState.WALLET &&
      isProticoAuthenticated === false
          ) ? (
            renderButton(
              "PIN_Profile_Signin_Request",
              "PIN_Signin_Verify_Wallet",
              handleProticoAuthenticate
            )
          ) : (
            <></>
          )}
            
        </div>
      )}
    </div>
  );
};

export default SmallAppsPage;
